module.exports = __webpack_public_path__ + "img/profiles.7b62674.jpg";